"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHueByCoordinates = getHueByCoordinates;

/**
 * Converts coordinates to hue.
 * @param x X-coordinate.
 * @param width The width of the canvas.
 */
function getHueByCoordinates(x, width) {
  var h = x / width * 360;
  return h;
}